export enum Portal {
  Vcc = "vcc",
  Polestar = "polestar",
}
